import styled from 'styled-components'

export const Container = styled.div`
  padding: var(--space-600);
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-400);
  color: var(--text-primary);
`

export const StatusList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-800);
`

export const StatusItem = styled.div`
  display: flex;
  flex-direction: column;
`

export const StatusLabel = styled.div`
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  text-transform: capitalize;
  margin-bottom: var(--space-100);
`

export const ProgressText = styled.div`
  font-size: var(--font-size-200);
  color: var(--text-secondary);
  margin-top: var(--space-100);
`

export const PendingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
  font-size: var(--font-size-300);
  color: var(--text-secondary);
`
